"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSlider = void 0;

var _react = _interopRequireWildcard(require("react"));

var momentjs = _interopRequireWildcard(require("moment"));

var _ = require("../");

var _MomentRow = require("../organisms/MomentRow");

require("./VideoSlider.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VideoSlider = function VideoSlider(_ref) {
  var containerRef = _ref.containerRef,
      momentTicks = _ref.momentTicks,
      jump = _ref.jump,
      fluidSourcesInfo = _ref.fluidSourcesInfo;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      scrubbedVal = _useState2[0],
      setScrubbedVal = _useState2[1];

  var _useState3 = (0, _react.useState)({
    visibility: "hidden"
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      paddingStyle = _useState4[0],
      setPaddingStyle = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      timeHoverStyle = _useState6[0],
      setTimeHoverStyle = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      hoveredMoment = _useState8[0],
      setHoveredMoment = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showHover = _useState10[0],
      setShowHover = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      activeSvgLines = _useState12[0],
      setActiveSvgLines = _useState12[1];

  var _useState13 = (0, _react.useState)(window.innerWidth),
      _useState14 = _slicedToArray(_useState13, 2),
      windowWidth = _useState14[0],
      setWindowWidth = _useState14[1];

  var _useState15 = (0, _react.useState)(window.innerHeight),
      _useState16 = _slicedToArray(_useState15, 2),
      windowHeight = _useState16[0],
      setWindowHeight = _useState16[1];

  var _useState17 = (0, _react.useState)(0),
      _useState18 = _slicedToArray(_useState17, 2),
      thumbX = _useState18[0],
      setThumbX = _useState18[1];

  var time = (0, _react.useRef)(0);
  var duration = (0, _react.useRef)(0);
  var isDragging = (0, _react.useRef)(false);
  var multicamOpen = (0, _react.useRef)(false);
  var onTimeChange = (0, _react.useCallback)(function () {
    if (time.current && !isDragging.current) {
      changeThumbPosition(getXforTime(time.current));
    }
  }, [time]);
  var tickFuzz = 8;
  var firstRawVideo = fluidSourcesInfo.firstMainFluidSource; //// Listen for window resize

  var setWindowDimensions = function setWindowDimensions() {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  };

  (0, _react.useEffect)(function () {
    window.addEventListener("resize", setWindowDimensions);
    document.addEventListener("trc-video-info", onVideoUpdate);
    document.addEventListener("trc-video-info-loading", onVideoUpdate);
    return function () {
      window.removeEventListener("resize", setWindowDimensions);
      document.removeEventListener("trc-video-info", onVideoUpdate);
      document.removeEventListener("trc-video-info-loading", onVideoUpdate);
    };
  }, []); //// Update the slider's fill color

  (0, _react.useEffect)(function () {
    var _fluidSourcesInfo$fir;

    var activeSvg = [];
    var startTime = ((_fluidSourcesInfo$fir = fluidSourcesInfo.firstMainFluidSource) === null || _fluidSourcesInfo$fir === void 0 ? void 0 : _fluidSourcesInfo$fir.start_time) / 1000;
    var activeColor = "rgba(255, 255, 255, 0.5)";

    if (fluidSourcesInfo.activeFluidSources.length !== 0) {
      var _iterator = _createForOfIteratorHelper(fluidSourcesInfo.activeFluidSources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var fs = _step.value;
          var start = getXforTime(fs.start_time / 1000 - startTime);
          var end = getXforTime(fs.start_time / 1000 + fs.duration - startTime);
          activeSvg.push({
            start: start === 0 ? start : start + 8,
            end: end + 8,
            color: activeColor
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      // non-fluid
      var elem = document.getElementById("input");

      if (elem) {
        var clientRect = elem.getBoundingClientRect();
        var xMax = clientRect.right;
        activeSvg.push({
          start: 0,
          end: xMax,
          color: activeColor
        });
      }
    }

    setActiveSvgLines(activeSvg);
  }, [fluidSourcesInfo, firstRawVideo, setActiveSvgLines, windowWidth]); //// Slider Event handlers

  var onVideoUpdate = function onVideoUpdate(e) {
    var vi = e.detail;

    if (vi.video_id.includes(containerRef.current)) {
      if (vi.scrubber.duration !== duration.current) {
        duration.current = vi.scrubber.duration;
      }

      if (fluidSourcesInfo.firstMainFluidSource) {
        if (Math.abs(vi.scrubber.currentTime - time.current) > 1) {
          time.current = vi.scrubber.currentTime;
          updateTime(vi.scrubber.currentTime);
          onTimeChange();
        }
      } else if (Math.abs(vi.scrubber.currentTime - time.current) > 0.033) {
        time.current = vi.scrubber.currentTime;
        updateTime(vi.scrubber.currentTime);
        onTimeChange();
      } // eslint-disable-next-line eqeqeq


      if (vi.multicamOpen != multicamOpen.current) {
        multicamOpen.current = vi.multicamOpen;
      }
    }
  };

  var getTimeForX = function getTimeForX(x) {
    var elem = document.getElementById("input");

    if (elem) {
      var clientRect = elem.getBoundingClientRect();
      var xMin = clientRect.left;
      var xMax = clientRect.right;
      var length = xMax - xMin;
      var pxr = duration.current / length;
      return x * pxr;
    } else {
      return 0;
    }
  };

  var getXforTime = function getXforTime(time) {
    var elem = document.getElementById("input");

    if (elem) {
      var clientRect = elem.getBoundingClientRect();
      var xMin = clientRect.left;
      var xMax = clientRect.right;
      var length = xMax - xMin;
      var pxr = duration.current / length;
      return time / pxr;
    } else {
      return 0;
    }
  };

  var formatTime = function formatTime(time) {
    var ft = "--:--";
    var fgt = 0;
    var t = momentjs.duration((time + fgt) * 1000);
    var minutes = Math.floor(t.asMinutes());
    t.subtract(minutes, "minutes");
    var seconds = Math.floor(t.seconds());
    ft = minutes < 10 ? "0" : "";
    ft += minutes;
    ft += ":";
    ft += seconds < 10 ? "0" : "";
    ft += seconds;
    return ft;
  };

  var updateTime = function updateTime(time) {
    var timeDiv = document.querySelector(".VideoSlider .current-time");
    timeDiv.innerHTML = formatTime(time);
  };

  var onDragStart = function onDragStart(e) {
    isDragging.current = true;
  };

  var onDragEnd = function onDragEnd(e) {
    isDragging.current = false; // eslint-disable-next-line eqeqeq

    if (scrubbedVal != null) {
      jump(scrubbedVal);
      setScrubbedVal(null);
      (0, _.trackEvent)({
        action: "Video Scrubbed",
        element: e.target
      });
    } else {
      onClick(e);
    }
  };

  var onClick = function onClick(e) {
    var time;

    if (!hoveredMoment) {
      var elem = document.getElementById("input");
      var clientRect = elem.getBoundingClientRect();
      var xMin = clientRect.left;
      var xMax = clientRect.right;
      var mouseX = Math.min(Math.max(0, e.clientX - xMin - 8), xMax); // 8px - half width of the knob

      changeThumbPosition(mouseX);
      time = getTimeForX(mouseX);
    } else {
      var startTime = firstRawVideo.start_time / 1000;
      time = hoveredMoment.start_time - startTime;
      changeThumbPosition(getXforTime(time));
    }

    jump(time);
  };

  var onMouseMove = function onMouseMove(e) {
    var els = document.querySelectorAll(".canvas-container");

    var _iterator2 = _createForOfIteratorHelper(els),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var el = _step2.value;
        var ev = new MouseEvent("mousemove", e.nativeEvent);
        el.dispatchEvent(ev);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var elem = document.getElementById("input");
    var clientRect = elem.getBoundingClientRect();
    var xMin = clientRect.left;
    var xMax = clientRect.right;
    var length = xMax - xMin;
    var mouseX = null;

    if (e.touches) {
      mouseX = e.touches[0].clientX - xMin;
    } else {
      mouseX = e.clientX - xMin - 8;
    }

    if (mouseX < 0) {
      mouseX = 0;
    }

    var time = getTimeForX(mouseX);

    if (!isDragging.current && !(0, _.isLandscape)()) {
      var currentTick = null;

      var _iterator3 = _createForOfIteratorHelper(memoizedTicks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tick = _step3.value;

          if (mouseX >= tick.x - tickFuzz && mouseX < tick.x + tickFuzz) {
            currentTick = tick;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (currentTick) {
        setHoveredMoment(currentTick);
        var hoverCard = document.getElementById("timeline-hovercard");

        if (hoverCard) {
          var hovercardRect = hoverCard.getBoundingClientRect();
          var hovercardWidth = hovercardRect.width;
          var hovercardPadding = hovercardWidth / 2;

          if (currentTick.x + hovercardPadding > length) {
            setPaddingStyle({
              marginLeft: currentTick.x - hovercardPadding + 4 - (currentTick.x + hovercardPadding - 4 - length) + "px",
              color: "white",
              bottom: multicamOpen.current ? "235px" : "125px"
            });
          } else if (currentTick.x - hovercardPadding < 0) {
            setPaddingStyle({
              marginLeft: 0 + "px",
              color: "white",
              bottom: multicamOpen.current ? "235px" : "125px"
            });
          } else {
            setPaddingStyle({
              marginLeft: currentTick.x - hovercardPadding + "px",
              color: "white",
              bottom: multicamOpen.current ? "235px" : "125px"
            });
          }
        }
      } else {
        setHoveredMoment(null);
        setShowHover(true);
        var timeHover = document.querySelector(".VideoSlider .range .time-hover");

        if (timeHover) {
          var _iterator4 = _createForOfIteratorHelper(activeSvgLines),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var line = _step4.value;

              if (mouseX >= line.start - 8 && mouseX < line.end - 8) {
                timeHover.innerHTML = formatTime(time);
                setTimeHoverStyle({
                  marginLeft: "".concat(mouseX - 37.5, "px"),
                  bottom: multicamOpen.current ? "235px" : "125px",
                  width: "75px"
                });
                break;
              } else {
                timeHover.innerHTML = "no video";
                setTimeHoverStyle({
                  marginLeft: "".concat(mouseX - 50, "px"),
                  bottom: multicamOpen.current ? "235px" : "125px"
                });
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
    } else {
      if (hoveredMoment || showHover) {
        setHoveredMoment(null);
        setShowHover(false);
      }

      var slidingPx = 0;

      if (mouseX < 0) {
        slidingPx = 0;
      } else if (mouseX > length) {
        slidingPx = length;
      } else {
        slidingPx = mouseX;
      }

      var thumb = document.querySelector(".VideoSlider .video-slider .thumb");
      thumb.style.left = "".concat(slidingPx, "px");
      setThumbX(slidingPx + 8);
      setScrubbedVal(time);
    }
  };

  var onMouseLeave = function onMouseLeave() {
    setHoveredMoment(null);
    setShowHover(false);
    isDragging.current = false;
  };

  var changeThumbPosition = function changeThumbPosition(val) {
    var thumb = document.querySelector(".VideoSlider .video-slider .thumb");
    thumb.style.left = "".concat(val, "px");
    setThumbX(val + 8);
  }; //// memoize the tick values for display


  var memoizedTicks = (0, _react.useMemo)(function () {
    var newTicks = [];
    if (!firstRawVideo) return newTicks;
    var tickColor = "#ffffff";

    var _iterator5 = _createForOfIteratorHelper(momentTicks),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var tick = _step5.value;
        var goalTick = tick.tags.find(function (t) {
          return t.name === "goal";
        });
        tickColor = goalTick ? "var(--" + goalTick.background.replace("2", "1") + ")" : "#ffffff";
        var startTime = firstRawVideo.start_time / 1000;
        var opacity = 0.25;

        if ((hoveredMoment === null || hoveredMoment === void 0 ? void 0 : hoveredMoment.start_time) === tick.start_time || goalTick) {
          opacity = 1;
        }

        var elem = document.getElementById("input");

        if (elem) {
          var clientRect = elem.getBoundingClientRect();
          var xMin = clientRect.left;
          var xMax = clientRect.right;
          var length = xMax - xMin;
          var tickX = getXforTime(tick.start_time - startTime);
          newTicks.push(_objectSpread(_objectSpread({}, tick), {}, {
            x: tickX + 12 > length ? length - 14 : tickX,
            y: (hoveredMoment === null || hoveredMoment === void 0 ? void 0 : hoveredMoment.start_time) === tick.start_time ? "2px" : "5px",
            end: getXforTime(tick.end_time - startTime),
            fill: tickColor,
            opacity: opacity,
            timeStart: formatTime(tick.start_time - startTime),
            timeEnd: formatTime(tick.end_time - startTime)
          }));
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return newTicks;
  }, [momentTicks, hoveredMoment, firstRawVideo, windowHeight, windowWidth, duration.current]);
  return /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "VideoSlider"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    padding: "0 4 0 0",
    marginRight: "4",
    className: "current-time",
    type: _.Label.Type.Body,
    color: _.Color.White1,
    small: true,
    width: 48,
    content: "--:--"
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    span: "10",
    className: "range"
  }, hoveredMoment && /*#__PURE__*/_react.default.createElement(_.Element, {
    key: "hovercard-".concat(hoveredMoment.start_time),
    style: paddingStyle,
    marginBottom: 8,
    className: "timeline-hovercard",
    id: "timeline-hovercard"
  }, /*#__PURE__*/_react.default.createElement(_MomentRow.MomentAvatars, {
    name: "avatars",
    avatarSize: 40,
    players: hoveredMoment.players,
    marginBottom: "2"
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "tags",
    type: _.Label.Type.Body,
    content: hoveredMoment.tags.filter(function (tag) {
      return tag.title !== "TraceCam";
    }).map(function (t) {
      return t.title;
    }).join(", ")
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    type: _.Label.Type.Body,
    content: "".concat(hoveredMoment.timeStart, " - ").concat(hoveredMoment.timeEnd)
  })), !hoveredMoment && showHover && /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "time-hover",
    style: timeHoverStyle,
    marginBottom: 8
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    tag: "div",
    id: "input",
    className: "video-slider",
    min: "0",
    step: "0.001",
    max: duration.current,
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave,
    onTouchStart: onDragStart,
    onTouchMove: onMouseMove,
    onMouseDown: onDragStart,
    onMouseUp: onDragEnd,
    onTouchEnd: onDragEnd
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "svg-layer"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "100%",
    height: "26px"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "round-corner"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "19",
    width: "100%",
    height: "4",
    rx: "2",
    ry: "2"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "range-mask",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    height: "100%",
    fill: "white",
    x: "0",
    width: thumbX
  }), /*#__PURE__*/_react.default.createElement("rect", {
    height: "100%",
    fill: "black",
    x: thumbX,
    width: "calc(100% - ".concat(thumbX, "px)")
  }))), memoizedTicks.map(function (tick, idx) {
    return /*#__PURE__*/_react.default.createElement("circle", {
      key: "circle-".concat(idx),
      cx: "".concat(tick.x + 8, "px"),
      cy: tick.y,
      r: "2px",
      fill: tick.fill,
      opacity: tick.opacity
    });
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "19",
    width: "100%",
    fill: "rgba(57,60,60,0.5)",
    height: "8",
    className: "svg-range",
    clipPath: "url(#round-corner)"
  }), activeSvgLines.map(function (line, idx) {
    return /*#__PURE__*/_react.default.createElement("g", {
      key: "range-".concat(idx)
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "".concat(line.start, "px"),
      y: "19",
      width: "".concat(line.end - line.start, "px"),
      opacity: "1",
      fill: "white",
      height: "8",
      className: "svg-range",
      mask: "url(#range-mask)",
      clipPath: "url(#round-corner)"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "".concat(line.start, "px"),
      y: "19",
      width: "".concat(line.end - line.start, "px"),
      opacity: ".6",
      fill: line.color,
      height: "8",
      className: "svg-range",
      clipPath: "url(#round-corner)"
    }));
  }))), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "thumb"
  }))));
};

exports.VideoSlider = VideoSlider;